<template>
  <SharedEnquiryClassic :id="id" />
</template>

<script>
import SharedEnquiryClassic from './SharedEnquiryClassic.vue'

// The Enquiry page route. One layout only (Mohammed 23/10): the layout setting and ?view= choose the New Enquiry form.
export default {
  name: 'JobPageEntry',
  components: { SharedEnquiryClassic },
  props: { id: { type: Number, required: true } }
}
</script>
